
let initialState = {
    cohort_progress: {
        game1: 0,
        game2: 0,
        game3: 0,
        game4: 0,
        game5: 0
    },
    game_coverage: {
        game1: 0,
        game2: 0,
        game3: 0,
        game4: 0,
        game5: 0
    }
}

export default function gamesPercentageReducer(state = initialState, action) {
    switch (action.type) {
        case "FETCH_GAME_COMPLETED_PERCENTAGES_SUCCESS":
            return {
                ...state,
                ...action.payload
            }
        default: return state
    }

}
